export const selectCaptureNotificationsData = (state) =>
  state.capture.captureNotificationsWidget.data;

export const selectCaptureNotificationsLoading = (state) =>
  state.capture.captureNotificationsWidget.isLoading;

export const selectCaptureNotificationsError = (state) =>
  state.capture.captureNotificationsWidget.error;
